import { ErrorHandler, Inject, Injectable, Optional } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Injectable()
export class CustomErrorHandlerService implements ErrorHandler {
  constructor(@Optional() @Inject('ERROR_WRAPPER') private errorWrapper: any) {}

  handleError(error: Error) {
    console.error('CustomErrorHandlerService.handleError', error);

    error = error['originalError'] || error['error'] || error;

    if (error['rejection']?.message?.includes('Http failure response')) {
      error = new Error(`${error['rejection'].message} - ${error['rejection'].error?.message}`);
    }

    if (this.errorWrapper) {
      this.errorWrapper.error = error;
    } else Sentry.captureException(error);
  }
}
